import React from 'react'
import PropTypes from 'prop-types';
import NoticeIcon from 'images/icons/notice-icon-red.inline.svg'
import * as Tooltip from '@radix-ui/react-tooltip';
import { toolTipContent, toolTipArrow} from './compatibleNotice.module.scss'

const noticeStyle = {
    verticalAlign: 'middle',
    lineHeight: '1',
    marginLeft: '0.4rem'
}

function CompatibleNotice({
    title,
    showNotice
}){
    return(
        showNotice && (
            <Tooltip.Provider >
            <Tooltip.Root >
              <Tooltip.Trigger asChild>
                <span style={noticeStyle}>
                    <NoticeIcon />
                </span>
              </Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content className={toolTipContent} sideOffset={3} side="bottom">
                  {title}
                  <Tooltip.Arrow className={toolTipArrow} />
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          </Tooltip.Provider>
        )
    )
}

CompatibleNotice.propTypes = {
    title: PropTypes.string.isRequired,
    showNotice: PropTypes.bool.isRequired
}

export default CompatibleNotice